import * as React        from "react";
import {formatNumberBig} from "../../../../language/format-number-big";
import {PAGE_SIZE_ALL}   from "../pagination-ui/page-size/page-size";

export const getPageSummary = ({pageIndex, pageSize, count}) => (
    <div className="page-summary" xd-qa-type="text" xd-qa-name="Page Summary">
        <div className="page-rows-list">
            {pageSize === PAGE_SIZE_ALL ? (
                "1-" + formatNumberBig(count) + " of " + formatNumberBig(count) + ""
            ) : (
                formatNumberBig(pageIndex * pageSize + 1) +
                "-" +
                formatNumberBig(
                    Math.min(count, (pageIndex + 1) * pageSize)
                ) +
                " of " +
                formatNumberBig(count) +
                ""
            )}
        </div>
    </div>
);
